import React, { memo } from "react";
import * as PR from "../../prime-modules/index";

const TabsBlock = (props) => {
  const appName = process.env.REACT_APP_NAME;
  const previousInterval = props?.previousInterval
  const tabList = props ? props.selectedTabs : [
    {
        "id": "revenue",
        "name": "Revenue",
        "previousIntervalVal": "0",
        "currentIntervalVal": "0",
        "percentageDiff": "0"
    },
    {
        "id": "bundlesSold",
        "name": "Bundles Sold",
        "previousIntervalVal": "0",
        "currentIntervalVal": "0",
        "percentageDiff": "0"
    },
  ];
  const recurringRevenueList = props ? props.recurringTab : [
    {
      "id": "recurringRevenue",
      "name": "Recurring Revenue",
      "previousIntervalVal": "0",
      "currentIntervalVal": "0",
      "percentageDiff": "0"
    },
  ]
  const activeList = props ? props.activeTab : [
    {
        "id": "activeSubscriptions",
        "name": "Active Subscriptions",
        "previousIntervalVal": "0",
        "currentIntervalVal": "0",
        "percentageDiff": "0"
    },
  ]
  const cancelList = props ? props.cancelTab : [
    {
        "id": "cancelledSubscriptions",
        "name": "Cancelled Subscriptions",
        "previousIntervalVal": "0",
        "currentIntervalVal": "0",
        "percentageDiff": "0"
    },
  ];

  const finalTabList =
    appName === "data2go-iot"
      ? [...tabList, ...recurringRevenueList, ...activeList, ...cancelList]
      : tabList;

  const renderPercentageDiff = (percentageDiff) => {
    if (percentageDiff === "+∞") {
      return "+∞";
    } else if (percentageDiff === "-∞") {
      return "-∞";
    } else if (percentageDiff != null) {
      return `${Math.abs(percentageDiff)}%`;
    } else {
      return "";
    }
  };  

  return (
    <>
      <div className="grid">
        {finalTabList.length > 0 ? (
          finalTabList.map((tab, index) => (
            <div className="col-12 md:col-6 lg:col-3 sm:col-6 col-custom-width" key={index}>
              <div className="p-3 border-1 border-50 border-round tabs-block-bg">
                <div className="flex justify-content-between align-items-center mb-2 tabs-block-mobile">
                  <span>{tab.name}</span>
                </div>
                <div className="flex justify-content-between align-items-center mt-3 price-block-mobile">
                  <div className="w-12">
                    <div className={`tab-number flex align-items-center ${props?.loadingGraphs?.stats ? 'justify-content-center' : ''}`}>
                      {props?.loadingGraphs?.stats ? (
                      <div>
                        <PR.ProgressSpinner style={{width: '30px', height: '30px', justifyContent: "center", alignItems: "center"}} strokeWidth="6" fill="var(--surface-ground)" animationDuration=".5s"/>
                      </div>
                      ) : (
                      <>
                      <div className="mr-3">
                        {tab.currentIntervalVal}
                      </div>
                      {tab.percentageDiff && (
                        <PR.Tooltip target=".percentage" position="bottom">
                          {(props?.selectedDisplayOption === "Custom" && !props?.displayDate?.endDate)
                            ? `Compared to the last ${previousInterval} day`
                            : `Compared to the last ${previousInterval} days`
                          }
                        </PR.Tooltip>
                      )}

                      {tab.percentageDiff && (
                          <span
                            className={
                              "percentage " +
                              (tab.percentageDiff === "+∞" || tab.percentageDiff > 0
                                ? "up"
                                : tab.percentageDiff === "-∞" || tab.percentageDiff < 0
                                ? "down"
                                : "normal")
                            }
                          >
                            {(tab.percentageDiff === "+∞" || tab.percentageDiff > 0) && (
                              <i className="pi pi-arrow-up-right" />
                            )}
                            {(tab.percentageDiff === "-∞" || tab.percentageDiff < 0) && (
                              <i className="pi pi-arrow-down-left" />
                            )}
                            {renderPercentageDiff(tab.percentageDiff)}
                          </span>
                      )}
                      </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">No Tabs were selected to display</div>
        )}
      </div>
    </>
  );
};

export default memo(TabsBlock);
